import { render, staticRenderFns } from "./saleVolume.vue?vue&type=template&id=7b5681d4&scoped=true"
import script from "./saleVolume.vue?vue&type=script&lang=js"
export * from "./saleVolume.vue?vue&type=script&lang=js"
import style0 from "./saleVolume.vue?vue&type=style&index=0&id=7b5681d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5681d4",
  null
  
)

export default component.exports